/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ExamItemAnswerTextCorrectionSubGridItemRepositoryResponse } from "../types/ExamItemAnswerTextCorrectionSubGridItemRepositoryResponse.ts";
import { eComponentTypeSchema } from "./eComponentTypeSchema.ts";

export const examItemAnswerTextCorrectionSubGridItemRepositoryResponseSchema =
  z.object({
    id: z.optional(
      z.number().int().describe("ID da resposta dissertativa do aluno."),
    ),
    student: z
      .string()
      .describe("Nome do aluno que respondeu a questão dissertativa.")
      .nullish(),
    value: z
      .string()
      .describe("Conteúdo da resposta dissertativa enviada pelo aluno.")
      .nullish(),
    grade: z
      .number()
      .describe("Nota atribuída à resposta após a correção. Opcional.")
      .nullish(),
    personGrade: z
      .string()
      .describe(
        "Nota da pessoa (professor/correto) associada à correção. Opcional.",
      )
      .nullish(),
    componentType: z.optional(
      z
        .lazy(() => eComponentTypeSchema)
        .describe(
          "1 = SingleChoice | 2 = MultipleChoice | 3 = SingleLineText | 4 = MultilineText | 5 = Numeric | 6 = Grade | 7 = Audio | 8 = Attachment | ",
        ),
    ),
  }) as unknown as ToZod<ExamItemAnswerTextCorrectionSubGridItemRepositoryResponse>;
